// src/components/Home.js
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './Home.css';

function Home() {
  const navigate = useNavigate();
  const [ultimosAlunos, setUltimosAlunos] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUltimosAlunos = async () => {
      const { data, error } = await supabase
        .from('alunos')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(5);

      if (error) {
        console.error('Erro ao buscar últimos alunos:', error);
        setError('Erro ao carregar os últimos alunos: ' + error.message);
        return;
      }
      setUltimosAlunos(data);
    };
    fetchUltimosAlunos();
  }, []);

  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) {
      console.error('Erro ao fazer logout:', error);
      return;
    }
    navigate('/');
  };

  return (
    <div className="home-container">
      <div className="logos-container">
        <img src="/assets/logo1.PNG" alt="Logo 1" className="logo" />
        <img src="/assets/logo2.png" alt="Logo 2" className="logo" />
      </div>
      <h1>Escolinha de Futebol</h1>
      <h2>Últimos Alunos Cadastrados</h2>
      {error && <p className="error-message">{error}</p>}
      {ultimosAlunos.length === 0 ? (
        <p>Nenhum aluno cadastrado ainda.</p>
      ) : (
        <ul className="ultimos-alunos-lista">
          {ultimosAlunos.map((aluno) => (
            <li key={aluno.id} className="ultimo-aluno-item">
              {aluno.foto_url && (
                <img src={aluno.foto_url} alt={aluno.nome} className="aluno-foto" />
              )}
              <div className="aluno-info">
                <span>{aluno.nome}</span> - Matrícula: {aluno.matricula}
              </div>
            </li>
          ))}
        </ul>
      )}
      <button onClick={() => navigate('/cadastro')}>Cadastrar Aluno</button>
      <button onClick={() => navigate('/lista')}>Lista de Alunos</button>
      <button onClick={() => navigate('/mensalidades')}>Controle de Mensalidades</button>
      <button onClick={() => navigate('/mensalidades-pagas')}>
        Mensalidades Pagas
      </button>
      <button onClick={handleLogout}>Sair</button>
    </div>
  );
}

export default Home;